// src/services/api/paymentVerification.js
import { apiClient } from './base';

export { uploadOrderPaymentProof } from './orders';

export const getPaymentRecords = async (params = {}) => {
  try {
    const response = await apiClient.get('/payment-verification', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updatePaymentRecord = async (id, data) => {
  try {
    const response = await apiClient.patch(`/payment-verification/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyPaymentRecord = async (id) => {
  try {
    const response = await apiClient.patch(`/payment-verification/${id}/verify`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const bulkVerifyPaymentRecords = async (paymentRecordIds) => {
  try {
    const response = await apiClient.patch('/payment-verification/bulk-verify', { paymentRecordIds });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const voidPaymentRecord = async (id, reason) => {
  try {
    const response = await apiClient.patch(`/payment-verification/${id}/void`, { reason });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const flagPaymentRecordIssue = async (id, reason) => {
  try {
    const response = await apiClient.patch(`/payment-verification/${id}/flag-issue`, { reason });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resolvePaymentRecordIssue = async (id, note) => {
  try {
    const response = await apiClient.patch(`/payment-verification/${id}/resolve-issue`, { note });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addPaymentRecordNote = async (id, note) => {
  try {
    const response = await apiClient.post(`/payment-verification/${id}/notes`, { note });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPaymentRecordNotes = async (id) => {
  try {
    const response = await apiClient.get(`/payment-verification/${id}/notes`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
